import React, {useState, useEffect, useRef} from "react";
import { Row,Col } from 'react-bootstrap';
import styled from "styled-components";
import Titulo from "../../../globals/Title";

const HeaderContainer = styled(Row)`
  margin: 0;
  width: 100%;
`;
const HeaderContainerM = styled(Row)`
  margin: 2px 0 6px;
  width: 100%;
  height:20px;

`;
const Container = styled(Row)`
  margin:0;
  padding:0;
  display:flex;
`;
const ColStyle = styled(Col)`
  margin:0;
  padding:0;
  display:flex;
  justify-content:${props => props.align};
  align-items:center;
`;
function Header (props){
  return (
    <Container id="principal_header_container">
      <HeaderContainer id="header_container">
        <ColStyle align={'start'}>
          <Titulo tipo={'Administracion'} nombre={'Perfil de Usuario'} showDetalle={props.isDetalle} filtro={props.actualGridConcepto}/>
        </ColStyle>
       
      </HeaderContainer>
    </Container>
    
  );
}
export default Header;